import React, { useState, useEffect, useRef } from "react";
import "./AdminPage.css";
import { assets } from "../../assets/assets";
import {
  doc,
  setDoc,
  getDocs,
  collection,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import { db, storage } from "../../Firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { TailSpin } from "react-loader-spinner";
import { LazyLoadImage } from "react-lazy-load-image-component";
import DeleteAlert from "./DeleteAlert";

const AdminPage = ({ show, onClose }) => {
  const [entries, setEntries] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    HEADING: "",
    DESCRIPTION: "",
    FROM_DATE: "",
    TO_DATE: "",
    IMAGE: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [imagePreview, setImagePreview] = useState(""); // Add this state
  const [loading, setLoading] = useState(false);

  const [deleteMode, setDeleteMode] = useState(false);
  const [adminNumber, setAdminNumber] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const formRef = useRef(null);

  //   const fetchEntries = async () => {
  //     try {
  //       const querySnapshot = await getDocs(
  //         query(collection(db, "PACKAGES"), where("STATUS", "==", "ACTIVE"))
  //       );
  //       const fetchedEntries = [];
  //       querySnapshot.forEach((doc) => {
  //         fetchedEntries.push({ id: doc.id, ...doc.data() });
  //       });
  //       setEntries(fetchedEntries);
  //     } catch (error) {
  //       console.error("Error fetching documents:", error);
  //     }
  //   };

  const fetchEntries = async () => {
    try {
      const querySnapshot = await getDocs(
        query(collection(db, "PACKAGES"), where("STATUS", "==", "ACTIVE"))
      );
      const fetchedEntries = [];
      querySnapshot.forEach((doc) => {
        fetchedEntries.push({ id: doc.id, ...doc.data() });
      });

      // Sort the entries by date, latest entries first
      fetchedEntries.sort(
        (a, b) => new Date(b.FROM_DATE) - new Date(a.FROM_DATE)
      );

      setEntries(fetchedEntries);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  const fetchAdminNumber = async () => {
    try {
      const docSnapshot = await getDocs(collection(db, "ADMIN"));
      const adminData = [];
      docSnapshot.forEach((doc) => {
        adminData.push(doc.data());
      });

      if (adminData.length > 0) {
        setAdminNumber(adminData[0].NUMBER);
      }
    } catch (error) {
      console.error("Error fetching admin number:", error);
    }
  };

  const fetchAminData = () => {
    try {
      const collectionRef = doc(db, "ADMIN");
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    fetchEntries();
    fetchAdminNumber();
  }, []);

  const onAddClick = () => {
    setShowForm(true);
    setEditMode(false);
    setFormData({
      PACKAGE: "",
      HEADING: "",
      DESCRIPTION: "",
      FROM_DATE: "",
      TO_DATE: "",
      IMAGE: "",
      STATUS: "",
    });
    setImageFile(null);
    setImagePreview(""); // Clear image preview
  };

  const onEditClick = (entry) => {
    setShowForm(true);
    setEditMode(true);
    setEditId(entry.id);
    setFormData({
      PACKAGE: entry.PACKAGE,
      HEADING: entry.HEADING,
      DESCRIPTION: entry.DESCRIPTION,
      FROM_DATE: entry.FROM_DATE,
      TO_DATE: entry.TO_DATE,
      IMAGE: entry.IMAGE,
      STATUS: entry.STATUS,
    });
    setImagePreview(entry.IMAGE); // Set image preview to existing image

     // Scroll to the form when edit is clicked

     formRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const confirmDelete = (entry) => {
    setConfirm(true);
    setSelectedEntry(entry); // Set the entry you want to delete
  };

  const confirmNot = () => {
    setConfirm(false);
    setSelectedEntry(null); // Clear the selected entry when canceling
  };

  const handleDelete = async () => {
    try {
      setLoading(true);

      if (selectedEntry) {
        // Update document to mark it as deleted
        await updateDoc(
          doc(db, "PACKAGES", selectedEntry.id),
          { STATUS: "DELETED" },
          {
            merge: true,
          }
        );
        console.log("Document marked as deleted");

        // Update the entries state by filtering out the deleted entry
        setEntries(entries.filter((e) => e.id !== selectedEntry.id));
        setLoading(false);
        setConfirm(false);
        setSelectedEntry(null); // Clear the selected entry after deletion
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      setLoading(false);
    }
  };

  //   const onFormSubmit = async (e) => {
  //     e.preventDefault();
  //     const timestamp = Date.now().toString();

  //     try {
  //       setLoading(true);
  //       let imageUrl = formData.IMAGE;

  //       if (imageFile) {
  //         const fileRef = ref(storage, `${timestamp}/${imageFile.name}`);
  //         await uploadBytes(fileRef, imageFile);
  //         imageUrl = await getDownloadURL(fileRef);
  //         console.log("Image uploaded successfully. URL:", imageUrl);
  //       }

  //       const entryData = {
  //         ...formData,
  //         IMAGE: imageUrl,
  //         STATUS: "ACTIVE",
  //       };

  //       if (editMode) {
  //         // Update existing document
  //         await updateDoc(doc(db, "PACKAGES", editId), entryData);
  //         console.log("Document updated successfully:", entryData);
  //       } else {
  //         // Add new document
  //         await setDoc(doc(db, "PACKAGES", timestamp), entryData, {
  //           merge: true,
  //         });
  //         console.log("Document added successfully:", entryData);
  //       }
  //       setLoading(false);

  //       setFormData({
  //         HEADING: "",
  //         DESCRIPTION: "",
  //         FROM_DATE: "",
  //         TO_DATE: "",
  //         IMAGE: "",
  //       });
  //       setImageFile(null);
  //       setImagePreview(""); // Clear image preview
  //       setShowForm(false);
  //       setEditMode(false);
  //       setEditId(null);
  //       setDeleteMode(false); // Ensure delete mode is reset
  //       fetchEntries(); // Refresh the list of entries
  //     } catch (error) {
  //       console.error("Error adding/updating document:", error);
  //     }
  //   };

  const onFormSubmit = async (e) => {
    e.preventDefault();
    const timestamp = Date.now().toString();

    if (!formData.HEADING && !formData.FROM_DATE && !formData.TO_DATE) {
      return alert("Please Fill Data");
    }

    try {
      setLoading(true);
      let imageUrl = formData.IMAGE;

      if (imageFile) {
        const fileRef = ref(storage, `${timestamp}/${imageFile.name}`);
        await uploadBytes(fileRef, imageFile);
        imageUrl = await getDownloadURL(fileRef);
        console.log("Image uploaded successfully. URL:", imageUrl);
      }

      const entryData = {
        ...formData,
        IMAGE: imageUrl,
        STATUS: "ACTIVE",
      };

      if (editMode) {
        // Update existing document
        await updateDoc(doc(db, "PACKAGES", editId), entryData);
        console.log("Document updated successfully:", entryData);

        // Update the entries state directly
        setEntries((prevEntries) =>
          prevEntries.map((entry) =>
            entry.id === editId ? { id: editId, ...entryData } : entry
          )
        );
      } else {
        // Add new document
        await setDoc(doc(db, "PACKAGES", timestamp), entryData, {
          merge: true,
        });
        console.log("Document added successfully:", entryData);

        // Add the new entry at the beginning of the entries array
        setEntries((prevEntries) => [
          { id: timestamp, ...entryData },
          ...prevEntries,
        ]);
      }

      setLoading(false);
      setFormData({
        PACKAGE: "",
        HEADING: "",
        DESCRIPTION: "",
        FROM_DATE: "",
        TO_DATE: "",
        IMAGE: "",
      });
      setImageFile(null);
      setImagePreview(""); // Clear image preview
      setShowForm(false);
      setEditMode(false);
      setEditId(null);
      setDeleteMode(false); // Ensure delete mode is reset
    } catch (error) {
      console.error("Error adding/updating document:", error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);

    // Set image preview
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options); // 'en-GB' formats as dd/mm/yyyy
  };

  return (
    <div className="admin_page">
      <div className="head">
        <div className="logo">
          <img src={assets.Logo} alt="Logo" />
        </div>
        <ul>
          <li>Admin</li>
          <li>{adminNumber}</li>
        </ul>
      </div>
      <div className="total_container">
        <h3>Manage Tour Packages</h3>
        <button className="add" onClick={onAddClick}>
          Add
        </button>

        {showForm && (
          <div className="add_container" ref={formRef}>
            <div className="form_container_add_section">
              <form onSubmit={onFormSubmit}>
                <div className="item_imageChange_add">
                  <label>
                    
                    { imagePreview ? "Edit" : "Image" } :
                    <input
                      type="file"
                      name="IMAGE"
                      accept="image/*"
                      title={` ${imagePreview} ? ${imagePreview} : "Chose your Image" `}
                      onChange={handleImageChange}
                    />
                  </label>
                  {imagePreview && (
                    <div className="image_preview">
                      <img src={imagePreview} alt="Preview" />
                    </div>
                  )}
                </div>

                <div className="item_contentChange_add_section">

                  <label className="packege_code" >
                  Package:
                    <input
                      placeholder="Enter package code.."
                      type="text"
                      name="PACKAGE"
                      value={formData.PACKAGE}
                      onChange={handleInputChange}
                    />
                  </label>



                  <label className="add_header">
                    Heading:
                    <input
                      placeholder="Heading..."
                      type="text"
                      name="HEADING"
                      value={formData.HEADING}
                      onChange={handleInputChange}
                    />
                  </label>

                  <label className="add_desc">
                    Description:
                    <input
                      placeholder="Description..."
                      type="text"
                      name="DESCRIPTION"
                      value={formData.DESCRIPTION}
                      onChange={handleInputChange}
                    />
                  </label>
                  <label className="add_date">
                    From Date:
                    <input
                      type="date"
                      name="FROM_DATE"
                      value={formData.FROM_DATE}
                      onChange={handleInputChange}
                    />
                  </label>

                  <label className="add_date">
                    To Date:
                    <input
                      type="date"
                      name="TO_DATE"
                      value={formData.TO_DATE}
                      onChange={handleInputChange}
                    />
                  </label>
                  {loading ? (
                    <button type="submit_add_btn">
                      <TailSpin color="#ffff" height={15} width={15} />
                    </button>
                  ) : (
                    <button type="submit_add_btn">
                      {editMode ? "Update" : "Submit"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}

        <div className="item_changeList">
          {entries.map((entry) => (
            <div className="item_admin" key={entry.id}>
              <div className="item_imageChange">
                <LazyLoadImage
                  src={entry.IMAGE}
                  effect="blur"
                  placeholderSrc={entry.IMAGE}
                  className="lazy-load-image"
                />
              </div>
              <div className="item_contentChange">
                <h4>{entry.PACKAGE}</h4>
                <h6>{entry.HEADING}</h6>
                <p>{entry.DESCRIPTION}</p>
                <span style={{ marginRight: "5px", fontWeight: "500" }}>
                  From:
                </span>
                <span style={{ marginRight: "10px" }}>
                  {formatDate(entry.FROM_DATE)}
                </span>
                <span style={{ marginRight: "5px", fontWeight: "500" }}>
                  to
                </span>
                <span>{formatDate(entry.TO_DATE)}</span>
                <div className="buttonAll">
                  <button className="edit" onClick={() => onEditClick(entry)}>
                    Edit
                  </button>
                  <button
                    onClick={() => confirmDelete(entry)}
                    className="delete"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <DeleteAlert
          show={confirm}
          onClose={confirmNot}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default AdminPage;
